module.exports = __webpack_public_path__ + "static/media/logoNavBar.ec628470.png";